import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home";
import store from "@/store";
import ActionTypes from "@/store/action-types";

import Help from "./Help";
import MOT from "./MOT";
import TFlowRestriction from "./TFlowRestriction";
import Dashboard from "./Dashboard";
import DeviceManager from "./DeviceManager";
import ChangeRequests from "./ChangeRequests";
import Environment from "@/environment";
import VUHistory from "./VUHistory";
import VUFeed from "./VUFeed";
import WorkerPresence from "./WorkerPresence";
import FloodDss from "./FloodDss";
import FleetTracker from "./FleetTracker";

Vue.use(VueRouter);

const router = new VueRouter({
	base: "/Client",
	mode: "history",
	routes: [
		{
			path: "/",
			name: "Home",
			component: Home
		},
		{
			path: "/Unauthorized",
			name: "Unauthorized",
			component: () => import("@/views/Unauthorized"),
			meta: {
				allowAnonymous: true
			}
		},
		{
			path: "/ResetPassword/:token?",
			name: "ResetPassword",
			props: true,
			component: () =>
				import(
					/* webpackChunkName: "ResetPassword" */ "@/views/Account/ResetPassword/Index"
				),
			meta: {
				allowAnonymous: true
			}
		},
		{
			path: "/ContactUs/",
			name: "ContactUs",
			props: true,
			component: () =>
				import(
					/* webpackChunkName: "ContactPage" */ "@/views/ContactUs/ContactPage"
				),
			meta: {
				allowAnonymous: true
			}
		},
		{
			// redirect old reset password url
			path: "/Account/ResetPassword/:token?",
			props: true,
			redirect: "/ResetPassword/:token?",
			meta: {
				allowAnonymous: true
			}
		},
		Dashboard,
		DeviceManager,
		ChangeRequests,
		VUHistory,
		VUFeed,
		Help,
		MOT,
		TFlowRestriction,
		WorkerPresence,
		FloodDss,
		FleetTracker,
		//{
		//path: "/about",
		//name: "about",
		// // route level code-splitting
		// // this generates a separate chunk (about.[hash].js) for this route
		// // which is lazy-loaded when the route is visited.
		//component: () =>
		// // the "webpackChunkName" comment on the following line matters!
		//import(/* webpackChunkName: "about" */ "./views/About.vue")
		//},
		{
			// When a URL matches multiple routes the route defined earliest is given priority.
			// Defining the catchall route last in order to ensure it has the lowest possible priority.
			path: "*",
			name: "NotFound",
			component: () => import("@/views/NotFound"),
			meta: {
				allowAnonymous: true
			}
		}
	]
});

// This promise is used in the router.beforeEach method to prevent routing occuring before
// the user's information has been loaded.
const storeInit = store.dispatch(ActionTypes.INIT);

// Add allowAnonymous: true to a routes meta field to allow unauthenticated users on a view
// Add authorizedRoles as an array of strings to designate permitted roles on a view
router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.allowAnonymous)) {
		next();
		return;
	}

	storeInit.then(() => {
		const haveUsername =
			store.state.user.username &&
			typeof store.state.user.username === "string";

		// If we don't have a username ie the user is not logged in.
		if (!haveUsername) {
			if (
				Environment.getIsProductionEnvironment() ||
				Environment.getCurrentEnvironmentData() == "TEST_ENV_KEY"
			) {
				window.location.href =
					window.location.protocol + "//" + window.location.host;
				return;
			} else {
				next("/Unauthorized");
				return;
			}
		}

		// If route requires authorization
		let routeRequiresRoles = to.matched.some(
			record => record.meta.authorizedRoles
		);
		if (routeRequiresRoles) {
			// Loop through each match and check user has at least one permission required.
			let index = 0;
			do {
				if (
					to.matched[index]["meta"] &&
					to.matched[index]["meta"]["authorizedRoles"]
				) {
					// If user doesn't have at least one permission required, then
					// redirect to unauthorized page.
					const rolesRequired = to.matched[index].meta.authorizedRoles;
					if (
						!rolesRequired.some(role => store.getters.currentUserHasRole(role))
					) {
						next("/Unauthorized");
						return;
					}
				}

				index++;
			} while (index < to.matched.length);
		}

		// If we got here, then the user has permissions to requested route.
		next();
	});
});

export default router;
